import { Component } from 'react';
import { connect } from 'react-redux';

import { Button, Pane, Tab, Tablist } from 'evergreen-ui';
import { Link } from 'react-router-dom';
import DataTable from '../../common/DataTable/DataTable';
import { getOrders } from '../actions/OrderActions';
import { getOrderColumns } from '../components/orderColumns';
import IntervalModal from '../components/IntervalModal';
import { ThreadsModal } from '../../../v2/features/threads/ThreadsModal';

class ListOrders extends Component {
    constructor(props) {
        super(props);

        this.openIntervalModal = this.openIntervalModal.bind(this);
        this.closeIntervalModal = this.closeIntervalModal.bind(this);
        this.setOrderView = this.setOrderView.bind(this);


        this.state = {
            activeOrders: 0,
            intervalModalOpen: false,
            selectedTab: 'orders',
            currentOpts: {},
            threadsTarget: null
        }
    }

    openIntervalModal() {
        this.setState({
            intervalModalOpen: true
        })
    }

    closeIntervalModal() {
        this.setState({
            intervalModalClosed: true
        })
    }

    openThreads = (target) => {
        this.setState({ threadsTarget: target });
    }


    handleTableChange = (opts) => {
        this.setState({
            currentOpts: opts
        })


        opts.start = opts.start || 0;
        opts.limit = opts.limit || 20;
        opts.sort = opts.sort || 'id';
        opts.direction = opts.direction || 'desc';

        let extraFilters = {
            ...opts.extraFilters,
        };

        if(this.state.selectedTab === 'orders') {
            extraFilters = {
                ...opts.extraFilters,
                isPreorder: 0,
                isBackorder: null,
                isSingles: null,
                delivery: ['delivery', 'delivery-locker']
            }
        }

        if(this.state.selectedTab === 'singles') {
            extraFilters = {
                ...opts.extraFilters,
                isSingles: 1,
                delivery: ['delivery', 'delivery-locker', 'personal', 'personal-brasov']
            }
        }

        if(this.state.selectedTab === 'pickup-pl') {
            extraFilters = {
                ...opts.extraFilters,
                delivery: ['personal']
            }
        }

        if(this.state.selectedTab === 'pickup-bv') {
            extraFilters = {
                ...opts.extraFilters,
                delivery: ['personal-brasov']
            }
        }

        if(this.state.selectedTab === 'shop-sales') {
            extraFilters = {
                ...opts.extraFilters,
                orderType: 'physical'
            }
        }

        if(this.state.selectedTab === 'preorders') {
            extraFilters = {
                ...opts.extraFilters,
                isPreorder: 1
            }
        }

        if(this.state.selectedTab === 'backorders') {
            extraFilters = {
                ...opts.extraFilters,
                isBackorder: 1
            }
        }

        this.props.dispatch(getOrders({
            ...opts,
            extraFilters
        }));
    }

    setOrderView(view) {
        this.setState({
            selectedTab: view
        }, () => {
            this.handleTableChange(this.state.currentOpts);
        });
    }

    render() {
        const c = getOrderColumns({ onOpenThreads: this.openThreads, withPreview: true });
        // `id` stays first: the row menu's getLink reads item[0] as the order id.
        const columns = [
            { id: 'id', label: 'Id', show: true },
            c.issue,
            c.orderNumber,
            c.grandTotal,
            c.emailOrderCount,
            c.tags,
            c.type,
            c.status,
            c.payment,
            c.issuesCount,
            c.customer,
            c.email,
            c.createdAt,
            c.updatedAt
        ];

        return (<>
            <IntervalModal open={this.state.intervalModalOpen} onClose={this.closeIntervalModal} />

            <Pane display="flex" flexDirection="column" gap={10} marginBottom={16}>
                <Pane display="flex" justifyContent="space-between" width="100%">
                    <Pane display="flex">
                        <Link to="/orders/create">
                            <Button iconBefore="add" intent="none" appearance="primary">
                                Comanda noua
                            </Button>
                        </Link>
                    </Pane>

                    <Pane display="flex">
                        <Button intent="none" onClick={this.openIntervalModal}>
                            Export Facturi
                        </Button>

                        {this.state.activeOrders > 0 ?
                            <Button iconBefore="truck" intent="warning" appearance="primary" style={{ marginLeft: '10px' }} onClick={() => { this.sendShipperOrders() }}>
                                Trimite Comanda Curier ({this.state.activeOrders} Colete)
                            </Button> : null}
                    </Pane>
                </Pane>
            </Pane>

            <Tablist marginBottom={16} flexBasis={240} marginRight={24}>
                <Tab
                    aria-controls={`panel-orders`}
                    isSelected={this.state.selectedTab === 'orders'}
                    key={'orders'}
                    onSelect={() => this.setOrderView('orders')}
                >
                    Comenzi Online
                </Tab>
                <Tab
                    aria-controls={`panel-singles`}
                    isSelected={this.state.selectedTab === 'singles'}
                    key={'singles'}
                    onSelect={() => this.setOrderView('singles')}
                >
                    Singles
                </Tab>
                <Tab
                    aria-controls={`panel-pickup`}
                    isSelected={this.state.selectedTab === 'pickup-pl'}
                    key={'pickup-pl'}
                    onSelect={() => this.setOrderView('pickup-pl')}
                >
                    Comenzi Ridicare PL
                </Tab>
                <Tab
                    aria-controls={`panel-pickup`}
                    isSelected={this.state.selectedTab === 'pickup-bv'}
                    key={'pickup-bv'}
                    onSelect={() => this.setOrderView('pickup-bv')}
                >
                    Comenzi Ridicare BV
                </Tab>
                <Tab
                    aria-controls={`panel-preorders`}
                    isSelected={this.state.selectedTab === 'preorders'}
                    key={'preorders'}
                    onSelect={() => this.setOrderView('preorders')}
                >
                    Precomenzi
                </Tab>
                <Tab
                    aria-controls={`panel-backorders`}
                    isSelected={this.state.selectedTab === 'backorders'}
                    key={'backorders'}
                    onSelect={() => this.setOrderView('backorders')}
                >
                    Comenzi Furnizor
                </Tab>
                <Tab
                    aria-controls={`panel-shop-sales`}
                    isSelected={this.state.selectedTab === 'shop-sales'}
                    key={'shop-sales'}
                    onSelect={() => this.setOrderView('shop-sales')}
                >
                    Vanzari Magazin
                </Tab>
                <Tab
                    aria-controls={`panel-all`}
                    isSelected={this.state.selectedTab === 'all'}
                    key={'all'}
                    onSelect={() => this.setOrderView('all')}
                >
                    Toate
                </Tab>
            </Tablist>

            <DataTable
                defaultFilter='id'
                defaultDirection='desc'
                columns={columns}

                data={this.props.data}
                onTableChange={this.handleTableChange}

                updateKey={this.props.data}
                page={this.props.page}
                pageSize={this.props.pageSize}
                pageCount={this.props.pageCount}

                itemMenu={[
                    { getLink: (item) => `/orders/${item[0]}`, label: 'Detalii', icon: 'eye-open' },
                    { getLink: (item) => `/orders/${item[0]}/edit`, label: 'Editeaza', icon: 'edit' }
                ]}
            />

            <ThreadsModal target={this.state.threadsTarget} onClose={() => this.setState({ threadsTarget: null })} />
        </>)
    }
}

function mapStateToProps(state) {
    return state.orders;
}

export default connect(mapStateToProps)(ListOrders);
